import Shepherd from 'shepherd.js';

// Reserve the tour during its initial delay too. Shepherd.activeTour is only
// set by start(), so checking it alone permits two delayed tours to overlap.
let reservation = null;

export function isTourInProgress() {
  return Boolean(reservation || Shepherd.activeTour);
}

export function scheduleTour(tour, delay) {
  if (isTourInProgress()) return false;

  const owner = { tour, timer: null, release: null };
  const release = () => {
    clearTimeout(owner.timer);
    tour.off('complete', release);
    tour.off('cancel', release);
    if (reservation === owner) reservation = null;
  };
  owner.release = release;
  reservation = owner;
  tour.on('complete', release);
  tour.on('cancel', release);
  owner.timer = setTimeout(() => {
    if (reservation !== owner) return;
    if (Shepherd.activeTour && Shepherd.activeTour !== tour) {
      release();
      return;
    }
    tour.start();
  }, delay);
  return true;
}

export function disposeTour(tour) {
  if (!tour) return;
  const ownsReservation = reservation?.tour === tour;
  // A completed component can unmount after another tour has started.
  // Cancelling its old Shepherd instance would clear that new active tour.
  if (!ownsReservation && Shepherd.activeTour !== tour) return;
  if (ownsReservation) reservation.release();
  tour.cancel();
}
